import React from 'react'
import { FieldProps } from 'formik'
import { Radio } from '@material-ui/core'
import { StyledFormControlLabel } from './styled'

interface ICustomRadioFieldProps {
  value: string
  id: string
  label: React.ReactNode
  disabled?: boolean
}

export const CustomRadioField = ({
  field,
  value,
  id,
  label,
  disabled,
}: FieldProps<any> & ICustomRadioFieldProps) => (
  <StyledFormControlLabel
    value={value}
    control={
      <Radio
        color="primary"
        name={field.name}
        id={id}
        checked={value === field.value}
        onChange={field.onChange}
        onBlur={field.onBlur}
        disabled={disabled}
      />
    }
    label={label}
  />
)
